module.exports = __webpack_public_path__ + "img/menuIcon10.d6e97b98.png";